import { render, staticRenderFns } from "./PhdList.vue?vue&type=template&id=c91227f4&"
import script from "./PhdList.vue?vue&type=script&lang=js&"
export * from "./PhdList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports